export const getPermissions = payload => {
    return {
        type: "GET_PERMISSIONS",
        payload: payload
    }
}

